import React from 'react';
import GroupCell from './GroupCell';

type Props = {
    emptyGroupsData?: EmptyRuleGroup[];
    handleEditRow?: Function;
};

const EmptyRuleGroups = ({ emptyGroupsData, handleEditRow }: Props) => {
    return (
        <>
            {emptyGroupsData?.map((group: EmptyRuleGroup) => {
                return (
                    <div key={group.id} data-testid='empty-rule-group'>
                        <GroupCell data={group} handleEditRow={handleEditRow} />
                    </div>
                );
            })}
        </>
    );
};
export default React.memo(EmptyRuleGroups);
